module.exports = __webpack_public_path__ + "5efe7e8ee50a01f52867ca98efd6c2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 601
// module chunks = 0